import PropTypes from "prop-types";
import React from "react";
import {
  Typography,
  ListItem,
  ListItemText,
  ListItemIcon
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ResourceTypeIcon from "../../../components/Icons/ResourceTypeIcon";

const useStyles = makeStyles(theme => ({
  listItemContainer: {
    "&:hover $iconButton": {
      opacity: 1
    }
  },
  listItemGutters: {
    paddingLeft: theme.spacing(1.75)
  }
}));

const ResourceListItem = ({ item, onClick }) => {
  const classes = useStyles();

  return (
    <ListItem
      button
      alignItems="center"
      classes={{
        gutters: classes.listItemGutters,
        container: classes.listItemContainer
      }}
      onClick={onClick}
    >
      <ListItemIcon className={classes.icon}>
        <ResourceTypeIcon type={item.itemType} />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography component="div" variant="body1" color="textSecondary">
            {item.name}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default ResourceListItem;

ResourceListItem.propTypes = {
  onClick: PropTypes.func,
  item: PropTypes.shape({
    /**
     * The name of the resource
     */
    name: PropTypes.string,

    /**
     * The type of the resource
     */
    type: PropTypes.string
  })
};
